import styled from 'styled-components/macro';

export const BrandContainer = styled.div`
  width: calc(12rem + 1vw);
  padding: 3rem 0;
`;
